/*
 * @Author: cc
 * @Date: 2020-02-12 08:35:37
 * @LastEditTime: 2021-10-27 18:01:39
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\editingCenter\toutiaohao\service\toutiaohaoService.js
 * @Description:
 */
angular.module('toutiaohaoServiceModule', []).factory('toutiaohaoService', [
    'trsHttpService',
    '$q',
    'editingCenterService',
    'ueditorService',
    'storageListenerService',
    'editIsLock',
    '$window',
    'toutConst',
    'editcenterRightsService',
    function(trsHttpService, $q, editingCenterService, ueditorService, storageListenerService, editIsLock, $window, toutConst, editcenterRightsService) {
        return {

            /**
             * [addFuture 为控制器作用域增加通用功能]
             *
             * @param   {[type]}  vm              [vm description]
             * @param   {[type]}  methodNameList  [methodNameList description]
             *
             * @return  {[type]}                  [return description]
             */
            addFuture: function (vm, methodNameList) {
                for (var i = 0; i < methodNameList.length; i++) {
                    let methodName = methodNameList[i];
                    vm[methodName] = this[methodName];
                }
                return vm;
            },

            /**
             * [sendmessage 发送消息到IM]
             *
             * @return  {[type]}  [return description]
             */
            sendmessage: function () {
                let that = this;
                this.save(true).then((data) => {
                    const outerSourceId = that.list.METADATAID;
                    const title = that.list.TITLE;
                    let articleDocType = editingCenterService.getDocTypeId();
                    let articleMediaType = editingCenterService.getEditPageMediaType();
                    let url = getDetailUrl(articleMediaType);
                    const extraInfo = {
                        'articleDocType': articleDocType,
                        'articleMediaType': articleMediaType,
                        'articleUrl': url,
                        'mediatype': articleMediaType,
                        'account': $state.params.account,
                        'metadataid': outerSourceId,
                        'chnldocid': that.list.CHNLDOCID,
                        'channelid': that.list.CHANNELID
                    };
                    const info = {
                        messageBody: {
                            content: '',
                            extraInfo: JSON.stringify(extraInfo),
                            messageType: 'ARTICLE_DOC', 
                            outerSourceId: outerSourceId,
                            platform: '',
                            title: title
                        },
                        outerSourceId: '',
                        oprType: getOprType(),
                        objId: $state.params.account
                    };
                    editingCenterService.sendToStudio(info).then(function(result){
                        if (result.ISSUCCESS === 'true') {
                            setTimeout(() => {
                                window.close();
                            }, 2000);
                        }
                    });
                });
            },

            // 初始化头条稿件类型下拉框
            initSelect: function() {
                return [
                    {
                        name: '全部稿件',
                        value: '',
                    },
                    {
                        name: '新闻',
                        value: '1',
                    },
                    {
                        name: '视频',
                        value: '7',
                    },
                ];
            },
            // 初始化头条待编和待审按钮数据
            initEditerBtn: function(platform, account) {
                var defer = $q.defer();
                var compaildbtn = [
                    {
                        RIGHTINDEX: 901,
                        OPERDESC: '保存',
                        OPERFUN: 'save',
                    },
                    {
                        RIGHTINDEX: 902,
                        OPERDESC: '送审',
                        OPERFUN: 'Trial',
                        rightKey: 'toutiao.daibian.songshen'
                    },
                    {
                        RIGHTINDEX: 902,
                        OPERDESC: '签发',
                        OPERFUN: 'Sign',
                        rightKey: 'toutiao.daibian.qianfa'
                    },
                ];
                let pendingbtn = [
                    {
                        RIGHTINDEX: 901,
                        OPERDESC: '保存',
                        OPERFUN: 'save',
                    },
                    {
                        RIGHTINDEX: 902,
                        OPERDESC: '撤稿',
                        OPERFUN: 'Kill',
                        rightKey: 'toutiao.daishen.chegao'
                    },
                    {
                        RIGHTINDEX: 902,
                        OPERDESC: '签发',
                        OPERFUN: 'Sign',
                        rightKey: 'toutiao.daishen.qianfa'
                    },
                ];
                editcenterRightsService.initToutiaohaoListBtn(['toutiao.daibian', 'toutiao.daishen'][platform], account).then(function(rights) {
                    var btns = [compaildbtn, pendingbtn][platform];
                    defer.resolve(btns.filter(function(btn) {
                        return !btn.rightKey || rights[btn.rightKey];
                    }));
                });
                return defer.promise;
            },
            // 头条号通用检索服务
            retrieve: function(params) {
                var deffer = $q.defer();
                var basicParam = {
                    serviceid: 'mlf_hybasesearch',
                    methodname: 'queryForToutiaoToDoc',
                    searchParams: {},
                };
                basicParam.searchParams = JSON.stringify(angular.extend(basicParam.searchParams, params));
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), basicParam, 'post').then(
                    function(data) {
                        deffer.resolve(data);
                    },
                    function() {
                        deffer.reject('获取结果失败');
                    }
                );
                return deffer.promise;
            },
            // 返回list基础数据
            getList: function() {
                var baseList = {
                    TITLE: '',
                    VIDEOURL: '',
                    HTMLCONTENT: '',
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [{ isCreate: true }],
                    ORIGINAL: 0,
                    SPECIALDOC: 0,
                    VIDEOREL: [],
                    COVERTYPE: 1,
                    COVERLIST: [],
                    ISNOPAYMENT: '1',
                };
                return baseList;
            },

            /**
             * [initEditPath description] 跳转编辑页地址
             * @return  {[object]}  [return description] 编辑器跳转体质
             */
            initEditPath: function() {
                return {
                    1: 'toutiaohaonews',
                    7: 'toutiaohaovideo',
                };
            },

            /**
             * [toutiaohaoEditor description]
             *
             * @param   {[type]}  docType    [docType description]
             * @param   {[type]}  account    [account description]
             * @param   {[type]}  articleid  [articleid description]
             * @param   {[type]}  platform  [platform description]
             *
             * @return  {function}           [return description]
             */
            toutiaohaoEditor: function(docType, account, articleid, platform) {
                var routerName = `#/${toutConst.docTypeCheck[docType]}?account=` + account + '&articleid=' + articleid;
                routerName += '&platform=' + platform;
                editIsLock.isLock({METADATAID: articleid}, 20).then(function (data) {
                    if (data.ISLOCK === 'false') {
                        window.open(routerName);
                    } else {
                        editIsLock.checkUnlockPermissions({METADATAID: articleid}, data).then(function () {
                            window.open(routerName);
                        });
                    }
                });
            },

            /**
             * [qiehaoUnlock description] 企鹅号解锁方法
             *
             * @param   {[type]}  form       [form description] form表单名称
             * @param   {[type]}  articleid  [articleid description] 稿件id
             * @param   {[type]}  save       [save description] 保存方法
             * @param   {[type]}  list       [list description] 稿件数据
             *
             * @return  {function}           [return description]
             */
            toutiaohaoUnlock: function(form, articleid, save, list) {
                editingCenterService
                    .closeWinow(form.$dirty, ueditorService.contentTranscoding(list) !== ueditorService.bindContent())
                    .then(
                        function() {
                            save().then(function() {
                                // 保存成功后的处理
                                storageListenerService.addListenerToToutiaohao('save');
                                editIsLock.normalLock(articleid).then(function(data) {
                                    $window.close();
                                });
                            });
                        },
                        function() {
                            angular.isDefined(articleid)
                                ? editIsLock.normalLock(articleid).then(function(data) {
                                    $window.close();
                                })
                                : $window.close();
                        }
                    );
            }
        };
    },
]);
